import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";
import { useFiltersStore } from "~/stores/filters/useFilterStore";
import { FilterOption } from "~/types/filters.types";
import FilterToggle from "../ListToggle/FilterToggle";
import ItemList2 from "../ListLayout/ItemList2";

const Years = () => {
    const { t } = useTranslation();
    const isLoading = useFiltersStore(state => state.isLoadingYearFilters);
    const yearOptions = useFiltersStore(state => state.yearFilters);
    const { yearFilters, setYearFilters, setTriggerSearch } = useContext(AdvancedSearchContext);

    // Temp list for changes before update event
    const [tempList, setTempList] = useState<FilterOption[]>(yearFilters);
    const enableUpdate =
        tempList.length !== yearFilters.length ||
        !tempList.every(f => yearFilters.find(tf => tf.id === f.id));

    const handleUpdate = () => {
        // Update context data when update button is clicked
        if (tempList.length > 0) {
            setYearFilters(tempList);
        } else {
            setYearFilters([]);
        }

        setTriggerSearch(true);
    };

    const resetItems = () => setTempList(yearFilters);

    useEffect(() => {
        if (yearFilters.length > 0) setTempList(yearFilters);
    }, [yearFilters]);

    return (
        <FilterToggle
            label={t("year")}
            count={tempList.length}
            panelWidth={"w-[81px]"}
        >
            {({ open }) => (
                <ItemList2
                    label={`${t("years")}`}
                    items={yearOptions}
                    listItems={tempList}
                    setListItems={setTempList}
                    reset={!open}
                    resetFn={resetItems}
                    enableUpdate={enableUpdate}
                    updateFn={handleUpdate}
                    autoUpdate={true}
                    allowNoSelection={true}
                    isLoading={isLoading}
                />
            )}
        </FilterToggle>
    );
};

export default Years;
